module.exports = __webpack_public_path__ + "static/img/starlogoindex.725c6313.png";